import api from './api';

function urlBase64ToUint8Array(base64String) {
  const padding = '='.repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');
  const raw = atob(base64);
  const arr = new Uint8Array(raw.length);
  for (let i = 0; i < raw.length; ++i) arr[i] = raw.charCodeAt(i);
  return arr;
}

async function getServiceWorkerRegistration() {
  if (!('serviceWorker' in navigator)) return null;
  try {
    let reg = await navigator.serviceWorker.getRegistration('/');
    if (!reg) {
      reg = await navigator.serviceWorker.register('/service-worker.js');
    }
    // Wait until active
    if (!reg.active) {
      await new Promise((resolve) => {
        const sw = reg.installing || reg.waiting;
        if (!sw) { resolve(); return; }
        sw.addEventListener('statechange', () => {
          if (sw.state === 'activated') resolve();
        });
        setTimeout(resolve, 5000);
      });
    }
    return reg;
  } catch (e) {
    console.error('SW registration failed:', e);
    return null;
  }
}

export async function subscribeToPush() {
  if (!('PushManager' in window)) return false;

  const permission = await Notification.requestPermission();
  if (permission !== 'granted') return false;

  let step = 'init';
  try {
    step = 'sw-reg';
    const reg = await getServiceWorkerRegistration();
    if (!reg) { console.error('Push: no SW registration'); return false; }

    step = 'vapid-key';
    const { data } = await api.get('/push/vapid-public-key');
    if (!data.publicKey) { console.error('Push: no VAPID key'); return false; }

    step = 'pm-subscribe';
    const existingSub = await reg.pushManager.getSubscription();
    if (existingSub) {
      await existingSub.unsubscribe();
    }
    const subscription = await reg.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: urlBase64ToUint8Array(data.publicKey),
    });

    step = 'api-subscribe';
    await api.post('/push/subscribe', {
      subscription: subscription.toJSON(),
      timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    });

    console.log('Push: subscribed successfully');
    return true;
  } catch (e) {
    console.error(`Push subscription failed at step "${step}":`, e);
    return false;
  }
}

export async function unsubscribeFromPush() {
  try {
    const reg = await navigator.serviceWorker.getRegistration('/');
    if (reg) {
      const subscription = await reg.pushManager.getSubscription();
      if (subscription) await subscription.unsubscribe();
    }
    await api.delete('/push/subscribe');
    return true;
  } catch (e) {
    console.error('Push unsubscribe failed:', e);
    return false;
  }
}

export async function isPushSubscribed() {
  if (!('serviceWorker' in navigator) || !('PushManager' in window)) return false;
  try {
    const reg = await navigator.serviceWorker.getRegistration('/');
    if (!reg) return false;
    const sub = await reg.pushManager.getSubscription();
    return !!sub;
  } catch {
    return false;
  }
}
